export default __webpack_public_path__ + "static/media/logoPokemon.c93942ed.png";